import { render, staticRenderFns } from "./signupForm.vue?vue&type=template&id=513aa5e6"
import script from "./signupForm.vue?vue&type=script&lang=js"
export * from "./signupForm.vue?vue&type=script&lang=js"
import style0 from "./signupForm.vue?vue&type=style&index=0&id=513aa5e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports